"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIconTableCell = exports.StyledCommonTextTableCell = exports.ICON_CELL_PADDING = exports.TEXT_CELL_PADDING = void 0;
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
// hacks to remove the effect of text jumping when opening a row
exports.TEXT_CELL_PADDING = '10px 16px 2px';
exports.ICON_CELL_PADDING = '7px 16px 5px';
exports.StyledCommonTextTableCell = (0, styled_components_1.default)(material_1.TableCell) `
  line-height: 20px;
  padding: ${exports.TEXT_CELL_PADDING};
`;
exports.StyledIconTableCell = (0, styled_components_1.default)(material_1.TableCell) `
  padding: ${exports.ICON_CELL_PADDING};
`;
